// Modules
import cn from 'classnames';

// Types
import type { TCardBodyProps } from './Card.type';

// Styles
import styles from './styles.module.scss';

const CardBody = (props: TCardBodyProps) => {
  const {
    children,
    className,
    title,
    titleClassName,
    ...restProps
  } = props;

  const cardBodyCN = cn(className, styles.legion_card_body);
  const titleCN = cn(titleClassName, styles.body_title);

  return (
    <div className={cardBodyCN} {...restProps}>
      {title && (
        <p className={titleCN}>{title}</p>
      )}
      {children}
    </div>
  );
};

CardBody.displayName = 'CardBody';
export default CardBody;
